import {createFileRoute} from '@tanstack/react-router';
import {practitionerAdminGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';

import PractitionerDelete from '@/practitioner/views/practitioner/PractitionerDelete';

export const Route = createFileRoute(
  '/(practitioner)/company/practitioners/$practitionerId/delete'
)({
  component: PractitionerDelete,
  beforeLoad: grantUser(practitionerAdminGranted),
  loader: ({params}) => ({
    practitionerId: params.practitionerId
  })
});
